var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoToastSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 15C25 20.5228 20.5228 25 15 25C9.47715 25 5 20.5228 5 15C5 9.47715 9.47715 5 15 5C20.5228 5 25 9.47715 25 15Z",
    fill: "#59BD83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8536 17.9145L10.3991 15.4599C10.2669 15.3277 10.0875 15.2534 9.90044 15.2534C9.7134 15.2534 9.53402 15.3277 9.40176 15.4599C9.2695 15.5922 9.1952 15.7716 9.1952 15.9586C9.1952 16.0512 9.21344 16.1429 9.24888 16.2285C9.28432 16.3141 9.33627 16.3918 9.40176 16.4573L12.3585 19.414C12.6344 19.6899 13.08 19.6899 13.3559 19.414L20.8397 11.9302C20.9719 11.798 21.0462 11.6186 21.0462 11.4316C21.0462 11.2445 20.9719 11.0651 20.8397 10.9329C20.7074 10.8006 20.528 10.7263 20.341 10.7263C20.1539 10.7263 19.9746 10.8006 19.8423 10.9329L12.8536 17.9145Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoToastSuccess);
export default __webpack_public_path__ + "static/media/ico-toast-success.0e769f58e995ca59f0cca90dd5bc690d.svg";
export { ForwardRef as ReactComponent };